
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { parseTime,resetForm ,addDateRange} from "@/utils/ruoyi"

// 分页组件
// 字典数据组件
import DictData from '@/components/DictData'
import '@/assets/style/ruoyi.scss' // ruoyi css
// 字典标签组件
import DictTag from '@/components/DictTag'
import plugins from './plugins' // plugins
import Pagination from "@/components/pagination";
import "./permission"; // permission control
import './utils/rem'
import "@/assets/style/index.scss"; // global css
import '@/assets/style/element-variables.scss' // element 主题定制
import "swiper/css/swiper.css";
import { getConfigKey } from "@/api/config"
import { download } from '@/utils/request'
Vue.component('DictTag', DictTag)
DictData.install()
Vue.prototype.addDateRange = addDateRange
Vue.prototype.getConfigKey = getConfigKey
Vue.use(ElementUI);
Vue.prototype.resetForm = resetForm
Vue.use(plugins)
Vue.config.productionTip = false
Vue.prototype.parseTime = parseTime
Vue.component("Pagination", Pagination);
Vue.prototype.download = download

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
